import { render, staticRenderFns } from "./GetRadius.vue?vue&type=template&id=0a2ed974&scoped=true&"
import script from "./GetRadius.vue?vue&type=script&lang=js&"
export * from "./GetRadius.vue?vue&type=script&lang=js&"
import style0 from "./GetRadius.vue?vue&type=style&index=0&id=0a2ed974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2ed974",
  null
  
)

export default component.exports